"use strict";
/**
 * HVAC Efficiency Constants
 *
 * These constants define the SEER (Seasonal Energy Efficiency Ratio) rating values
 * and other efficiency-related constants used across mobile and web applications.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultHVACEfficiencyConfig = exports.HVAC_EFFICIENCY_CONSTANTS = void 0;
exports.HVAC_EFFICIENCY_CONSTANTS = {
    // SEER Rating Scale Values
    SEER: {
        MIN_VALUE: 0,
        MID_VALUE: 8,
        MAX_VALUE: 16,
        DEFAULT_VALUE: 7,
    },
    // Last Hour Rating Values
    LAST_HOUR_RATING: {
        DEFAULT_VALUE: 1.3,
    },
    // Gauge Display Sizes
    GAUGE: {
        DEFAULT_SIZE: 270,
    },
};
/**
 * Get default HVAC efficiency configuration
 */
const getDefaultHVACEfficiencyConfig = () => ({
    seerValue: exports.HVAC_EFFICIENCY_CONSTANTS.SEER.DEFAULT_VALUE,
    minValue: exports.HVAC_EFFICIENCY_CONSTANTS.SEER.MIN_VALUE,
    midValue: exports.HVAC_EFFICIENCY_CONSTANTS.SEER.MID_VALUE,
    maxValue: exports.HVAC_EFFICIENCY_CONSTANTS.SEER.MAX_VALUE,
    lastHourRating: exports.HVAC_EFFICIENCY_CONSTANTS.LAST_HOUR_RATING.DEFAULT_VALUE,
});
exports.getDefaultHVACEfficiencyConfig = getDefaultHVACEfficiencyConfig;
